import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M16 7l2 9m-10 -9l-2 9m-1 -9h14m2 5h-18","key":"svg-0"}]]

const IconPicnicTable = createReactComponent('outline', 'picnic-table', 'PicnicTable', __iconNode);

export default IconPicnicTable;